import type {
  ICampaignTargetCustom,
  ICustomCampaignTargetRule,
} from "@shared/common/custom-target-condition/types";

export const imwebUserLogin: ICustomCampaignTargetRule = {
  key: "IMWEB_USER_LOGIN",

  checkValidRule({ siteType }) {
    return siteType === "IMWEB";
  },

  getDefaultValue() {
    return {
      type: "CUSTOM",
      key: "IMWEB_USER_LOGIN",
      value: "EVERYONE",
    };
  },

  getShortLabel(target: ICampaignTargetCustom) {
    switch (target.value) {
      case "EVERYONE":
        return null;
      case "NO_LOGIN":
        return "비로그인 사용자";
      case "LOGIN":
        return "로그인 사용자";
      default:
        return null;
    }
  },

  checkPage(condition, { html }) {
    if (condition.key !== "IMWEB_USER_LOGIN") {
      return false;
    }

    if (condition.value === "EVERYONE") {
      return true;
    }

    /**
     * 테스트용 샘플
     *
     * 미로그인
     *  var MEMBER_HASH = '';
     *
     * 로그인
     *  var MEMBER_HASH = 'pboxmvp';
     */

    const isLogin = /var MEMBER_HASH = '(.+?)';/.test(html.innerHTML);

    switch (condition.value) {
      case "NO_LOGIN":
        return !isLogin;
      case "LOGIN":
        return isLogin;
    }
  },
};

export default imwebUserLogin;
